import React from "react";

import "./Footer.less";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  return (
    <div className="footer">
      {" "}
      <div className="sociales">
        {" "}
        <a href="">
          {" "}
          <span>Mercado Sergio</span>
        </a>
        <a
          href="https://wa.me/+5493513110502"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Enlace a WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} size="lg" className="icon" />{" "}
          {/* Puedes ajustar el tamaño con la prop 'size' */}
          <span>+54 9 351 3110502</span>
        </a>
        <a
          href="mailto:compra@mercadosergio.com"
          aria-label="Enviar correo electrónico"
        >
          {" "}
          <FontAwesomeIcon icon={faEnvelope} size="lg" className="icon" />
          <span>compra@mercadosergio.com </span>
        </a>
      </div>{" "}
    </div>
  );
}
